import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import ReactFlow, { addEdge, applyNodeChanges, applyEdgeChanges, Background, Controls, } from 'react-flow-renderer';
import settingsIcon from '../icons/settings.svg';
import { ReactFlowProvider } from 'reactflow';
import Modal from 'react-modal'; // Для диалогового окна
import './SettingsTab.css'; // Импортируем CSS стили
import 'reactflow/dist/style.css'; // Импорт стилей React Flow
import { v4 as uuidv4 } from 'uuid'; // Импортируем uuid

const SettingsTab = () => {
  const [workflows, setWorkflows] = useState([]);
  const [subWorkflows, setSubWorkflows] = useState([]);
  const [functions, setFunctions] = useState([]);
  const [nodes, setNodes] = useState([]);
  const [, setSelectedInputs] = useState([]);
  const [, setSelectedOutputs] = useState([]);
  const [edges, setEdges] = useState([]);
  const [nodeParameters, setNodeParameters] = useState({});
  const [selectedNode, setSelectedNode] = useState({
    name: '',
    description: '',
    typeSubWF: '',
    inputs: [],
    outputs: []
  });
  const [currentWfId, setCurrentWfId] = useState(null);
  const [currentsubWFId, setCurrentsubWFId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [currentWorkflow, setCurrentWorkflow] = useState({
    name: '',
    description: '',
    typeSubWF: '',
  });
  const [newFunction, setNewFunction] = useState({
    name: '',
    description: '',
    classifier: '',
    inputs: [],
    outputs: []
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentWorkflow((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (selectedNode) {
      setNodeParameters((prevNodeParameters) => {
        if (prevNodeParameters[selectedNode.id]) {
          return prevNodeParameters;
        }
        return {
          ...prevNodeParameters,
          [selectedNode.id]: {
            inputs: selectedNode.inputs || [],
            outputs: selectedNode.outputs || []
          }
        };
      });
    }
  }, [selectedNode]);
  
  useEffect(() => {
    if (selectedNode && nodeParameters[selectedNode.id]) {
      setSelectedInputs(nodeParameters[selectedNode.id].inputs || selectedNode.inputs || []);
      setSelectedOutputs(nodeParameters[selectedNode.id].outputs || selectedNode.outputs || []);
    } else if (selectedNode) {
      setSelectedInputs(selectedNode.inputs || []);
      setSelectedOutputs(selectedNode.outputs || []);
    } else {
      setSelectedInputs([]);
      setSelectedOutputs([]);
    }
  }, [selectedNode, nodeParameters]);
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlow`)
      .then(res => setWorkflows(res.data))
      .catch(err => console.error(err));

    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/SubWF/get-subwfs`)
      .then(res => setSubWorkflows(res.data))
      .catch(err => console.error(err));

    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Function/functions-with-parameters`)
      .then(res => {
        if (res.data && res.data.length > 0) {
          setFunctions(res.data);
        } else {
          const testFunctions = [
            { id: 1, name: 'Функция обработки данных', description: 'Обрабатывает входящие данные', inputs: [], outputs: [] },
            { id: 2, name: 'Функция валидации', description: 'Проверяет корректность данных', inputs: [], outputs: [] },
            { id: 3, name: 'Функция сохранения', description: 'Сохраняет данные в базу', inputs: [], outputs: [] },
            { id: 4, name: 'Функция отправки уведомлений', description: 'Отправляет уведомления пользователям', inputs: [], outputs: [] },
            { id: 5, name: 'Функция генерации отчетов', description: 'Создает отчеты по данным', inputs: [], outputs: [] },
            { id: 6, name: 'Функция архивирования', description: 'Архивирует старые данные', inputs: [], outputs: [] },
            { id: 7, name: 'Функция мониторинга', description: 'Отслеживает состояние системы', inputs: [], outputs: [] },
            { id: 8, name: 'Функция резервного копирования', description: 'Создает резервные копии', inputs: [], outputs: [] }
          ];
          setFunctions(testFunctions);
        }
      })
      .catch(err => {
        console.error(err);
        const testFunctions = [
          { id: 1, name: 'Функция обработки данных', description: 'Обрабатывает входящие данные', inputs: [], outputs: [] },
          { id: 2, name: 'Функция валидации', description: 'Проверяет корректность данных', inputs: [], outputs: [] },
          { id: 3, name: 'Функция сохранения', description: 'Сохраняет данные в базу', inputs: [], outputs: [] },
          { id: 4, name: 'Функция отправки уведомлений', description: 'Отправляет уведомления пользователям', inputs: [], outputs: [] },
          { id: 5, name: 'Функция генерации отчетов', description: 'Создает отчеты по данным', inputs: [], outputs: [] },
          { id: 6, name: 'Функция архивирования', description: 'Архивирует старые данные', inputs: [], outputs: [] },
          { id: 7, name: 'Функция мониторинга', description: 'Отслеживает состояние системы', inputs: [], outputs: [] },
          { id: 8, name: 'Функция резервного копирования', description: 'Создает резервные копии', inputs: [], outputs: [] }
        ];
        setFunctions(testFunctions);
      });
  }, []);

  const fetchWorkflows = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlow`);
    setWorkflows(response.data);
  };

  const loadWorkflow = async (wfId) => {
    setCurrentWorkflow({
      name: '',
      description: '',
      typeSubWF: '',
    });
    setNodes([]);
    setEdges([]);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlowInfo/${wfId}`);
      const data = await response.json();
  
      setCurrentWorkflow({
        name: data.name,
        description: data.description,
        typeSubWF: data.typeSubWF,
      });
  
      const newNodes = data.subWfs.map(subWf => ({
        id: subWf.id,
        position: subWf.position,
        type: subWf.type,
        data: {
          label: subWf.data.label,
          subWFId: subWf.subWFId,
        },
      }));
  
      setNodes(newNodes);
      setCurrentWfId(wfId);
  
      const connectionsResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/WfSubBranching/get-branchings/${wfId}`);
      const connections = await connectionsResponse.json();
  
      const newEdges = connections.map(connection => ({
        id: connection.id,
        source: connection.source,
        target: connection.target,
      }));
  
      setEdges(newEdges);
    } catch (error) {
      console.error('Error loading workflow:', error);
    }
  };

  const loadSubWorkflow = async (subWFId) => {
    setCurrentWorkflow({
      name: '',
      description: '',
      typeSubWF: '',
    });
    setNodes([]);
    setEdges([]);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/SubWFInfo/${subWFId}`);
      const data = await response.json();
      setCurrentWorkflow({
        name: data.name,
        description: data.description,
        typeSubWF: data.typeSubWF,
      });
  
      const newNodes = data.functions.map(func => ({
        id: func.id,
        position: func.position,
        type: func.type,
        data: {
          label: func.data.label,
          functionId: func.data.functionId,
          description: func.data.description,
          inputs: func.data.inputs,
          outputs: func.data.outputs,
        },
      }));
      setCurrentsubWFId(subWFId);
      setNodes(newNodes);
  
      const connectionsResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/SubWFFuncBranching/get-branchings/${subWFId}`);
      const connections = await connectionsResponse.json();
  
      const newEdges = connections.map(connection => ({
        id: connection.id,
        source: connection.source,
        target: connection.target,
      }));
  
      setEdges(newEdges);
    } catch (error) {
      console.error('Error loading sub-workflow:', error);
    }
  };

  useEffect(() => {
    fetchWorkflows();
  }, []);

  const handleCreate = (type) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/${type === 'WorkFlow' ? 'WorkFlow' : 'SubWF'}`;
    axios.post(url)
      .then(res => {
        const newElement = type === 'WorkFlow'
          ? { id: res.data.workFlowId, name: 'New WF' }
          : { id: res.data.subWfId, name: 'New SubWF' };

        if (type === 'WorkFlow') setWorkflows([...workflows, newElement]);
        else setSubWorkflows([...subWorkflows, newElement]);
      })
      .catch(err => console.error(err));
  };

  const openFunctionModal = () => setIsModalOpen(true);
  const closeFunctionModal = () => setIsModalOpen(false);

  const addParameter = (type) => {
    setNodeParameters((prev) => {
      const nodeData = { ...prev[selectedNode.id] };
      const newParam = { name: '', type: '', description: '', value: '' };
      nodeData[type] = [...nodeData[type], newParam];
      return { ...prev, [selectedNode.id]: nodeData };
    });
  
    if (type === 'inputs') {
      setSelectedInputs((prev) => [...prev, { name: '', type: '', description: '', value: '' }]);
    } else {
      setSelectedOutputs((prev) => [...prev, { name: '', type: '', description: '', value: '' }]);
    }
  };

  const handleParamChange = (index, value, type, field) => {
    setNodeParameters((prev) => {
      const nodeData = { ...prev[selectedNode.id] };
      const updatedParams = nodeData[type].map((param, i) =>
        i === index ? { ...param, [field]: value } : param
      );
      nodeData[type] = updatedParams;
      return { ...prev, [selectedNode.id]: nodeData };
    });

    if (type === 'inputs') {
      setSelectedInputs((prev) =>
        prev.map((param, i) => (i === index ? { ...param, [field]: value } : param))
      );
    } else {
      setSelectedOutputs((prev) =>
        prev.map((param, i) => (i === index ? { ...param, [field]: value } : param))
      );
    }
  };

  const newFuncHandleParamChange = (index, value, paramType, field) => {
    setNewFunction((prevFunction) => {
        const updatedParams = [...prevFunction[paramType]];
        updatedParams[index] = { ...updatedParams[index], [field]: value };
        
        return { ...prevFunction, [paramType]: updatedParams };
    });
  };
    
  const removeParameter = (index, type) => {
    setNodeParameters((prev) => {
      const nodeData = { ...prev[selectedNode.id] };
      nodeData[type] = nodeData[type].filter((_, i) => i !== index);
      return { ...prev, [selectedNode.id]: nodeData };
    });

    if (type === 'inputs') {
      setSelectedInputs((prev) => prev.filter((_, i) => i !== index));
    } else {
      setSelectedOutputs((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    []
  );

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    []
  );

  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    []
  );

  const onDrop = (event) => {
    event.preventDefault();
  
    const data = event.dataTransfer.getData('application/reactflow');
    const droppedFunction = JSON.parse(data);
  
    const newNodeId = uuidv4();
  
    const newNode = {
      id: newNodeId,
      functionId: droppedFunction.id,
      position: { x: event.clientX, y: event.clientY },
      type: 'default',
      data: {
        label: droppedFunction.name,
        description: droppedFunction.description,
        inputs: droppedFunction.inputs,
        outputs: droppedFunction.outputs,
      },
    };
  
    setNodes((nds) => [...nds, newNode]);
  
    setNodeParameters((prevParams) => ({
      ...prevParams,
      [newNodeId]: {
        inputs: droppedFunction.inputs,
        outputs: droppedFunction.outputs,
      },
    }));
  };

  const handleDeleteWorkflow = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот Workflow?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlowInfo/${id}`, {
          method: 'DELETE',
        });
        alert('Workflow успешно удалён');
        setWorkflows(workflows.filter(wf => wf.id !== id));
      } catch (error) {
        console.error('Ошибка при удалении Workflow:', error);
        alert('Не удалось удалить Workflow.');
      }
    }
  };

  const handleDeleteSubWF = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот SubWF?')) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/SubWFInfo/${id}`, {
          method: 'DELETE',
        });
        if (response.ok) {
          alert('SubWF успешно удалён');
          setSubWorkflows(subWorkflows.filter(sw => sw.id !== id));
        } else if (response.status === 400) {
          const errorData = await response.json();
          alert(errorData.message);
        }
      } catch (error) {
        console.error('Ошибка при удалении SubWF:', error);
        alert('Не удалось удалить SubWF.');
      }
    }
  };

  const handleDeleteFunction = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту функцию?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Function/functions-with-parameters/${id}`, {
          method: 'DELETE',
        });
        alert('Function успешно удалена');
        setFunctions(functions.filter(fn => fn.id !== id));
      } catch (error) {
        console.error('Ошибка при удалении Function:', error);
        alert('Не удалось удалить Function.');
      }
    }
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const newaddParameter = (paramType) => {
    const newParam = { name: '', value: '', type: '', description: '', number: newFunction[paramType].length + 1 };

    setNewFunction((prevFunction) => ({
        ...prevFunction,
        [paramType]: [...prevFunction[paramType], newParam]
    }));
  };
    
  const createFunction = () => {
    const functionData = {
      ...newFunction,
      inputs: newFunction.inputs.map(param => ({
        ...param,
        isRoot: true
      })),
      outputs: newFunction.outputs.map(param => ({
        ...param,
        isRoot: true
      }))
    };
  
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/Function/functions-with-parameters`, functionData)
      .then(res => {
        setFunctions([...functions, res.data]);
        closeFunctionModal();
      })
      .catch(err => console.error(err));
  };

  const handleNodeClick = (event, clickedNode) => {
    if (!clickedNode) {
      console.error("clickedNode is undefined in handleNodeClick");
      return;
    }
  
    const targetNode = nodes?.find((node) => node.id === clickedNode.id);
  
    if (targetNode && targetNode.data) {
      setSelectedNode({
        id: targetNode.id,
        label: targetNode.data.label || '',
        functionId: targetNode.data.functionId || '',
        description: targetNode.data.description || '',
        inputs: targetNode.data.inputs || [],
        outputs: targetNode.data.outputs || [],
      });
  
      setSelectedInputs(targetNode.data.inputs || []);
      setSelectedOutputs(targetNode.data.outputs || []);
    } else {
      console.error("Узел не найден в nodes или данные отсутствуют:", clickedNode.id);
    }
  };

  const onElementsRemove = (elementsToRemove) => {
    setNodes((nds) => applyNodeChanges(elementsToRemove, nds));
    setEdges((eds) => applyEdgeChanges(elementsToRemove, eds));
  };

  const saveWF = async () => {
    try {
      if (!currentWfId) {
        console.error("currentWfId не установлен");
        return;
      }
  
      let currentId = 1;
      const blockIds = {};
  
      const subWfsData = nodes.map((node) => {
        const generatedId = String(currentId++);
        blockIds[node.id] = generatedId;
  
        return {
          subWFId: node.data.subWFId || node.functionId || node.id,
          id: generatedId,
          position: node.position || { x: 0, y: 0 },
          type: node.type || "default",
          data: {
            label: node.data.label || "",
          },
        };
      });
  
      const wfInfo = {
        name: currentWorkflow.name || "defaultName",
        description: currentWorkflow.description || "defaultDescription",
        typeSubWF: currentWorkflow.typeSubWF || "defaultType",
        subWfs: subWfsData,
      };
  
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlowInfo/${currentWfId}`, wfInfo);
  
      const connectionsData = edges.map((edge, idx) => ({
        id: String(idx + 1),
        source: blockIds[edge.source],
        target: blockIds[edge.target],
      }));
  
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/WfSubBranching/update-branchings/${currentWfId}`, connectionsData);
      
      setWorkflows(prevWorkflows => 
        prevWorkflows.map(wf => 
          wf.id === currentWfId 
            ? { ...wf, name: currentWorkflow.name, description: currentWorkflow.description }
            : wf
        )
      );
      
      alert('Workflow успешно сохранен!');
    } catch (error) {
      console.error("Ошибка при сохранении workflow:", error);
      alert('Ошибка при сохранении workflow');
    }
  };

  const saveSubWF = async (subWFData = { functions: [] }, connections = []) => {
    try {
      if (!currentsubWFId) {
        console.error("currentsubWFId не установлен");
        return;
      }
  
      let currentId = 1;
      const blockIds = {};
  
      const functionsData = subWFData.functions.map((func) => {
        const generatedId = blockIds[func.id] || String(currentId++);
        blockIds[func.id] = generatedId;
  
        const functionId = func.functionId || func.data?.functionId;
        if (!functionId) {
          console.error(`Function ID отсутствует для узла с id ${func.id}`);
          return null;
        }
  
        const nodeParams = nodeParameters[func.id] || {
          inputs: func.data?.inputs || [],
          outputs: func.data?.outputs || []
        };
  
        return {
          id: generatedId,
          functionId: functionId,
          position: func.position || { x: 0, y: 0 },
          type: func.type || "default",
          data: {
            label: func.data.label,
            description: func.data.description,
            inputs: nodeParams.inputs.map((input, index) => ({
              number: input.number || index + 1,
              name: input.name || "",
              type: input.type || "",
              description: input.description || "",
              value: input.value || "",
              isRoot: input.isRoot || false,
            })),
            outputs: nodeParams.outputs.map((output, index) => ({
              number: output.number || index + 1,
              name: output.name || "",
              type: output.type || "",
              description: output.description || "",
              value: output.value || "",
              isRoot: output.isRoot || false,
            })),
          },
        };
      }).filter(Boolean);
  
      const subWFInfo = {
        name: currentWorkflow.name || subWFData.name,
        description: currentWorkflow.description || subWFData.description,
        typeSubWF: currentWorkflow.typeSubWF || subWFData.typeSubWF,
        functionCount: functionsData.length,
        functions: functionsData,
      };
  
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/SubWFInfo/${currentsubWFId}`, subWFInfo);
      console.log('SubWF data saved successfully!');
  
      const connectionsData = connections.map((connection, idx) => ({
        id: String(idx + 1),
        source: blockIds[connection.source],
        target: blockIds[connection.target],
      }));
  
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/SubWFFuncBranching/update-branchings/${currentsubWFId}`, connectionsData);
      console.log('SubWF connections saved successfully!');
      
      // Обновляем локальное состояние subWorkflows после успешного сохранения
      setSubWorkflows(prevSubWorkflows => 
        prevSubWorkflows.map(subWf => 
          subWf.id === currentsubWFId 
            ? { ...subWf, name: currentWorkflow.name, description: currentWorkflow.description }
            : subWf
        )
      );
      
      alert('SubWF успешно сохранен!');
    } catch (error) {
      console.error("Ошибка при сохранении subWF:", error);
      alert('Ошибка при сохранении subWF');
    }
  };
  
  return (
    <div className="settings-tab">
      <div className="tables">
        {/* Workflow Table */}
        <div className="workflow-table">
          <h3>WF</h3>
          <button className="small-button" onClick={() => handleCreate('WorkFlow')}>Создать WF</button>
          <div className="block-container">
            {workflows.map(item => (
              <div key={item.id} className="block-item" draggable onDragStart={(event) => {
                event.dataTransfer.setData('application/reactflow', JSON.stringify(item));
              }}>
                <div className="block-content">
                  <span className="block-title" title={item.name}>
                    {item.name}
                    {item.name && item.name.length > 15 && (
                      <div className="block-tooltip">{item.name}</div>
                    )}
                  </span>
                  <div className="block-actions">
                    <button onClick={() => loadWorkflow(item.id)}>
                      <img src={settingsIcon} alt="Settings" className="icon" />
                    </button>
                    <button className="delete-button" onClick={() => handleDeleteWorkflow(item.id)}>×</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sub Workflow Table */}
        <div className="workflow-table">
          <h3>SubWF</h3>
          <button className="small-button" onClick={() => handleCreate('SubWF')}>Создать SubWF</button>
          <div className="block-container">
            {subWorkflows.map(item => (
              <div key={item.id} className="block-item" draggable onDragStart={(event) => {
                event.dataTransfer.setData('application/reactflow', JSON.stringify(item));
              }}>
                <div className="block-content">
                  <span className="block-title" title={item.name}>
                    {item.name}
                    {item.name && item.name.length > 15 && (
                      <div className="block-tooltip">{item.name}</div>
                    )}
                  </span>
                  <div className="block-actions">
                    <button onClick={() => loadSubWorkflow(item.id)}>
                      <img src={settingsIcon} alt="Settings" className="icon" />
                    </button>
                    <button className="delete-button" onClick={() => handleDeleteSubWF(item.id)}>×</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Functions Table */}
        <div className="workflow-table">
          <h3>Функции</h3>
          <button className="small-button" onClick={openFunctionModal}>Создать функцию</button>
          <div className="block-container">
            {functions.map(item => (
              <div key={item.id} className="block-item" draggable onDragStart={(event) => {
                event.dataTransfer.setData('application/reactflow', JSON.stringify(item));
              }}>
                <div className="block-content">
                  <span className="block-title" title={item.name}>
                    {item.name}
                    {item.name && item.name.length > 15 && (
                      <div className="block-tooltip">{item.name}</div>
                    )}
                  </span>
                  <div className="block-actions">
                    <button className="delete-button" onClick={() => handleDeleteFunction(item.id)}>×</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Workflow Details */}
        <div className="workflow-details">
          <h3>Детали Workflow</h3>
          <label>
            Название:
            <input
              type="text"
              name="name"
              value={currentWorkflow.name}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Описание:
            <input
              type="text"
              name="description"
              value={currentWorkflow.description}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Тип SubWF:
            <input
              type="text"
              name="typeSubWF"
              value={currentWorkflow.typeSubWF}
              onChange={handleInputChange}
            />
          </label>
          <button onClick={() => saveWF()}>Сохранить WF</button>
          <button onClick={() => saveSubWF({ functions: nodes }, edges)}>Сохранить SubWF</button>
        </div>
      </div>

      {/* Flow Editor */}
      <ReactFlowProvider>
        <div className="flow-editor" onDrop={onDrop} onDragOver={onDragOver}>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            onNodeClick={handleNodeClick}
            onElementsRemove={onElementsRemove}
            fitView
          >
            <Background />
            <Controls />
          </ReactFlow>
        </div>
      </ReactFlowProvider>

      {/* Parameter Editor */}
      <div className="parameter-editor">
        <h3>Параметры узла</h3>
        {selectedNode && selectedNode.id ? (
          <div>
            <h4>{selectedNode.label}</h4>
            <p>{selectedNode.description}</p>
            
            <h5>Входящие параметры</h5>
            {nodeParameters[selectedNode.id]?.inputs?.map((input, index) => (
              <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px', alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Название"
                  value={input.name || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'inputs', 'name')}
                  style={{ flex: '1', minWidth: '60px' }}
                />
                <input
                  type="text"
                  placeholder="Тип"
                  value={input.type || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'inputs', 'type')}
                  style={{ flex: '1', minWidth: '50px' }}
                />
                <input
                  type="text"
                  placeholder="Описание"
                  value={input.description || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'inputs', 'description')}
                  style={{ flex: '1', minWidth: '60px' }}
                />
                <input
                  type="text"
                  placeholder="Значение"
                  value={input.value || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'inputs', 'value')}
                  style={{ flex: '1', minWidth: '50px' }}
                />
                <button onClick={() => removeParameter(index, 'inputs')} style={{ padding: '2px 6px', fontSize: '12px' }}>×</button>
              </div>
            ))}
            <button onClick={() => addParameter('inputs')}>Добавить входящий параметр</button>
            
            <h5>Исходящие параметры</h5>
            {nodeParameters[selectedNode.id]?.outputs?.map((output, index) => (
              <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px', alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Название"
                  value={output.name || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'outputs', 'name')}
                  style={{ flex: '1', minWidth: '60px' }}
                />
                <input
                  type="text"
                  placeholder="Тип"
                  value={output.type || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'outputs', 'type')}
                  style={{ flex: '1', minWidth: '50px' }}
                />
                <input
                  type="text"
                  placeholder="Описание"
                  value={output.description || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'outputs', 'description')}
                  style={{ flex: '1', minWidth: '60px' }}
                />
                <input
                  type="text"
                  placeholder="Значение"
                  value={output.value || ''}
                  onChange={(e) => handleParamChange(index, e.target.value, 'outputs', 'value')}
                  style={{ flex: '1', minWidth: '50px' }}
                />
                <button onClick={() => removeParameter(index, 'outputs')} style={{ padding: '2px 6px', fontSize: '12px' }}>×</button>
              </div>
            ))}
            <button onClick={() => addParameter('outputs')}>Добавить исходящий параметр</button>
          </div>
        ) : (
          <p>Выберите узел для редактирования параметров</p>
        )}
      </div>

      {/* Modal for creating functions */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeFunctionModal}
        contentLabel="Создать функцию"
        className="modal"
        overlayClassName="modal-overlay"
      >
        <div style={{ padding: '20px', maxHeight: '80vh', overflowY: 'auto' }}>
          <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Создать новую функцию</h2>
          
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'grid', gap: '15px', marginBottom: '20px' }}>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <span style={{ fontWeight: 'bold' }}>Название:</span>
                <input
                  type="text"
                  value={newFunction.name}
                  onChange={(e) => setNewFunction({ ...newFunction, name: e.target.value })}
                  style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
              </label>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <span style={{ fontWeight: 'bold' }}>Описание:</span>
                <input
                  type="text"
                  value={newFunction.description}
                  onChange={(e) => setNewFunction({ ...newFunction, description: e.target.value })}
                  style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
              </label>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <span style={{ fontWeight: 'bold' }}>Классификатор:</span>
                <input
                  type="text"
                  value={newFunction.classifier}
                  onChange={(e) => setNewFunction({ ...newFunction, classifier: e.target.value })}
                  style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
              </label>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '10px', borderBottom: '2px solid #007bff', paddingBottom: '5px' }}>Входящие параметры</h3>
            <div style={{ marginBottom: '10px' }}>
              {newFunction.inputs.map((input, index) => (
                <div key={index} style={{ 
                  display: 'grid', 
                  gridTemplateColumns: '1fr 1fr 2fr 1fr', 
                  gap: '8px', 
                  marginBottom: '8px',
                  padding: '8px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  border: '1px solid #e9ecef'
                }}>
                  <input
                    type="text"
                    placeholder="Название"
                    value={input.name}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'inputs', 'name')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Тип"
                    value={input.type}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'inputs', 'type')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Описание"
                    value={input.description}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'inputs', 'description')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Значение"
                    value={input.value}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'inputs', 'value')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                </div>
              ))}
            </div>
            <button 
              onClick={() => newaddParameter('inputs')}
              style={{ 
                padding: '8px 16px', 
                backgroundColor: '#28a745', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              + Добавить входящий параметр
            </button>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '10px', borderBottom: '2px solid #dc3545', paddingBottom: '5px' }}>Исходящие параметры</h3>
            <div style={{ marginBottom: '10px' }}>
              {newFunction.outputs.map((output, index) => (
                <div key={index} style={{ 
                  display: 'grid', 
                  gridTemplateColumns: '1fr 1fr 2fr 1fr', 
                  gap: '8px', 
                  marginBottom: '8px',
                  padding: '8px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  border: '1px solid #e9ecef'
                }}>
                  <input
                    type="text"
                    placeholder="Название"
                    value={output.name}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'outputs', 'name')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Тип"
                    value={output.type}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'outputs', 'type')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Описание"
                    value={output.description}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'outputs', 'description')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                  <input
                    type="text"
                    placeholder="Значение"
                    value={output.value}
                    onChange={(e) => newFuncHandleParamChange(index, e.target.value, 'outputs', 'value')}
                    style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '3px' }}
                  />
                </div>
              ))}
            </div>
            <button 
              onClick={() => newaddParameter('outputs')}
              style={{ 
                padding: '8px 16px', 
                backgroundColor: '#dc3545', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              + Добавить исходящий параметр
            </button>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '10px', 
            justifyContent: 'center',
            borderTop: '1px solid #e9ecef',
            paddingTop: '20px'
          }}>
            <button 
              onClick={createFunction}
              style={{ 
                padding: '10px 20px', 
                backgroundColor: '#007bff', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Создать функцию
            </button>
            <button 
              onClick={closeFunctionModal}
              style={{ 
                padding: '10px 20px', 
                backgroundColor: '#6c757d', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Отмена
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SettingsTab;
